var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarbineVariant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.731 27.21L116.676 26.544C116.676 26.544 116.942 25.386 116.709 24.6465C116.477 23.907 114.318 21.2745 114.318 21.2745L110.211 16.3875L105.384 16.314L95.3029 16.1625L88.2769 15.4545L86.8054 15.213L85.7374 15.024L85.0474 15.0105L84.4054 15.1815L83.5234 15.0345L82.9909 15.213L82.1194 14.808H80.9479L79.6609 10.728L76.4974 11.394L75.9979 10.728C75.9979 10.728 75.1654 10.6035 74.4754 11.022C73.7854 11.442 72.8974 11.328 72.8974 11.328C72.8974 11.328 61.1884 14.241 59.7109 14.808C58.2334 15.3735 57.5764 16.3605 56.7709 17.8245C55.9669 19.2885 55.8049 19.455 55.8049 19.455C55.8049 19.455 41.0914 20.079 38.6494 20.523C36.2074 20.967 35.6254 21.633 35.6254 21.633L8.23838 21.9105L2.41088 23.1315L1.91138 23.7675L2.35538 24.8655L1.91138 25.4925L2.62238 26.253L8.18288 27.516H16.8544C17.1034 27.516 28.6369 27.852 28.6369 27.852C28.6369 27.852 31.1719 30.54 32.8774 31.3755C34.5829 32.2095 36.9964 32.1525 38.2984 32.265C39.6004 32.3775 44.1814 32.955 45.7834 33.177C47.3869 33.3975 54.4444 34.4325 56.9749 34.9935C59.5054 35.5545 63.0514 38.7 64.0039 39.9645C64.9564 41.2275 70.0354 44.4345 71.4724 45.306C72.9094 46.1775 75.7444 47.0655 75.7444 47.0655L76.9969 46.893L77.9314 47.592C77.9314 47.592 80.2819 48.108 82.3474 48.69C84.4129 49.272 86.2744 49.0575 87.6874 49.062C89.1004 49.0665 94.5094 48.582 94.5094 48.582L95.5144 47.151L95.0029 45.861L95.1814 45.444L96.1369 45.2385L96.2554 44.487C96.3739 43.7355 97.4329 42.8925 98.0809 42.558C98.7289 42.2235 102.381 41.43 102.381 41.43L111.387 39.4245C111.387 39.4245 114.216 36.729 115.001 35.6685C115.785 34.608 116.562 32.247 116.82 31.626C117.078 31.005 116.601 30.69 116.601 30.69L117.726 29.9535V27.2145L117.731 27.21ZM85.2664 30.5955C85.2664 30.5955 85.2949 34.1745 85.2664 34.6185C85.2379 35.0625 85.2109 36.4215 83.7679 36.477C82.3249 36.5325 82.1584 35.118 82.1584 35.118L80.8549 35.145C80.8549 35.145 78.9124 35.9775 75.7774 34.2255C72.6424 32.4735 72.4759 29.7195 72.4759 29.7195H73.3639L73.8904 29.208V27.123L73.2799 26.766V26.1H75.0004L75.4999 26.5155L77.6644 24.9645C77.6644 24.9645 79.8844 24.7395 80.4664 24.9645C81.0484 25.1895 81.9094 26.253 81.9094 26.253C82.6309 24.519 84.4969 24.7875 85.0729 25.545C86.5429 27.48 84.1294 28.59 84.1294 28.59C85.4884 29.166 85.2664 30.5955 85.2664 30.5955V30.5955ZM106.215 28.404L106.187 28.986L105.771 29.346V30.372L106.34 30.9135C106.34 30.9135 104.841 32.661 103.967 33.66C103.092 34.659 102.593 34.224 102.593 34.224C102.593 34.224 100.553 34.2 99.8044 34.224C99.0559 34.248 97.8484 33.7005 97.8484 33.7005L91.4809 31.578C91.4809 31.578 89.8159 31.287 89.8999 29.718C89.9824 28.149 91.6894 27.9165 91.6894 27.9165C91.6894 27.9165 97.5574 25.8765 98.4739 25.503C99.3889 25.128 99.8884 25.254 99.8884 25.254C99.8884 25.254 104.757 25.3785 105.674 25.4625C106.589 25.5465 106.797 26.544 106.797 26.544H106.242L105.827 27.0435L105.798 27.9585L106.214 28.4025L106.215 28.404Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.91235 23.7673L2.41185 23.1313L8.23785 21.9103",
    fill: "#FAFAFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0715 18.4124C56.0715 18.4124 56.823 18.9134 60.195 18.6359C63.567 18.3584 69.5595 17.2484 69.5595 17.2484L69.948 16.0829L74.3325 15.3614L75.054 16.1384L76.4415 15.9164L77.496 14.3069L76.779 11.3279",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5608 17.2485L70.7953 18.2475L72.4738 17.97L73.0558 17.2485L76.5523 16.749L78.3838 18.2475C78.3838 18.2475 78.9523 19.1355 80.2018 18.4695L79.0108 17.0955L80.8273 15.024",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4495 16.8705L82.774 15.1815",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9902 16.8705L84.0552 15.213",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4048 16.8705L85.5883 15.213",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9036 16.8704L87.2866 15.4544",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2302 16.6094L91.7712 17.5949L91.4382 18.7169L85.9032 18.7199C85.9032 18.7199 83.1567 18.4694 81.7002 20.0924C80.2437 21.7154 79.6602 22.2989 79.6602 22.2989",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4397 18.7184L97.6827 20.4269L105.465 18.4694L105.819 16.4294",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6829 20.4269V21.9524",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.962 30.915L105.34 33.7035C105.34 33.7035 104.174 35.118 103.426 35.16C102.677 35.202 99.9713 35.16 99.9713 35.16C99.9713 35.16 99.4718 35.2845 98.0153 34.827C96.5588 34.3695 90.1898 32.496 90.1898 32.496C90.1898 32.496 87.7763 31.605 87.6923 29.7195C87.6098 27.834 89.4818 27.1545 90.4808 26.766C91.4798 26.3775 97.6808 24.5025 97.6808 24.5025C97.6808 24.5025 98.8463 24.171 100.427 24.213C102.008 24.255 106.337 24.21 106.337 24.21L108.877 26.253",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.339 28.1264H108.129L108.879 28.7084L108.255 29.2499H106.09",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5227 23.295C83.5227 23.295 85.4862 23.628 86.0697 24.504C86.6532 25.38 86.3187 25.8795 86.7777 25.962C87.2367 26.0445 89.1912 25.962 89.1912 25.962L97.6812 23.295H107.08",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0969 21.9525V23.295",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M100.762 21.9525V23.295",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M102.385 21.8384V23.2949",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M103.801 21.8384V23.2949",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2519 42.6105L96.5859 41.223C96.5859 41.223 96.2394 40.53 96.5859 39.864C96.9324 39.198 97.6824 37.7415 97.6824 37.7415L97.8069 36.2325",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6829 37.7415L103.218 38.9895C103.218 38.9895 104.425 39.114 104.799 39.738C105.174 40.362 105.309 40.7895 105.309 40.7895",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5947 43.11L95.0067 45.858",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9553 41.3625L77.4958 44.22V47.0625",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0089 43.1099L77.4954 44.2199",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4973 30.4154L49.6093 33.7394L48.1663 33.4814C48.1663 33.4814 48.3043 32.4404 48.9433 31.9484C49.5823 31.4564 50.0533 31.6499 50.4973 30.4154Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9118 30.6719L51.9683 33.7379H50.7053C50.7053 33.7379 50.7188 32.6969 51.3578 32.2049C51.9968 31.7129 52.4678 31.9064 52.9118 30.6719Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3293 30.9869L54.2268 34.3799L52.9143 34.1129C52.9143 34.1129 53.1378 33.0134 53.7768 32.5199C54.4158 32.0264 54.8868 32.2214 55.3308 30.9869H55.3293Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2118 30.8729L56.4598 34.9904L55.3303 34.4414C55.3303 34.4414 55.3438 33.6509 55.9828 33.1574C56.6203 32.6654 57.7693 32.1074 58.2133 30.8729H58.2118Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5598 30.6854C70.5598 30.6854 72.3358 36.9494 79.6603 37.5044",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6731 30.6854C68.6731 30.6854 70.5601 39.1169 79.6606 39.4214",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3608 35.2769L80.6038 36.4799L81.4498 37.3379V39.4214L80.3608 40.1129V41.2724",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9029 43.1099L84.9954 41.0009L87.9279 35.2769L88.4829 34.3799H90.2034L90.8004 35.2769L92.7564 36.2129",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7122 22.5209H75.9552L77.2182 23.2949L77.4957 24.8654",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7954 23.6939H72.9449L74.9984 26.0999",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9476 14.808H82.1191L82.6141 15.213L83.6506 15.0105L84.0556 15.213L85.0471 15.0105L85.5871 15.213H86.8036L87.4351 15.528L94.7791 16.1595L95.2291 16.6095L95.5441 16.0695L105.818 16.4295L110.504 16.3845L112.04 18.4695C112.04 18.4695 114.204 21.216 114.786 21.7995C115.368 22.3815 116.951 24.546 116.951 25.545C116.951 26.544 116.535 27.0435 116.535 27.0435H112.539L109.959 24.879L108.878 25.0455L105.548 21.7995L85.0696 22.0485L83.9041 23.13H80.4916L79.6591 22.2975L77.9941 22.38L75.7471 20.466C75.7471 20.466 66.5911 19.9665 65.5921 20.217C64.5931 20.466 61.4296 21.3825 61.4296 21.3825L55.6021 19.3845C55.6021 19.3845 56.8231 16.1385 59.7091 14.8065C62.5951 13.4745 73.2496 11.0595 73.2496 11.0595C73.2496 11.0595 73.4986 11.226 74.2906 11.0595C75.0826 10.893 75.9976 10.7265 75.9976 10.7265L76.4971 11.3925C76.4971 11.3925 79.3276 10.7265 79.4521 10.7265C79.5766 10.7265 80.9476 14.8065 80.9476 14.8065V14.808Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M55.604 19.3859C55.604 19.3859 38.009 20.4674 36.8585 20.7449C35.708 21.0224 35.153 21.6329 35.153 21.6329L8.23854 21.9104L6.18504 22.4654L2.41104 23.1314L1.80054 23.9084C1.80054 23.9084 2.35554 24.2414 2.35554 24.6299C2.35554 25.0184 1.80054 25.2959 1.80054 25.2959L2.30004 26.1839L6.29604 27.0434L8.18304 27.5144H28.3595L30.1805 29.7194C30.1805 29.7194 31.823 31.7879 36.596 32.1209C41.369 32.4539 48.8045 33.6194 48.8045 33.6194C48.8045 33.6194 57.0185 33.9524 60.8465 37.2824C64.676 40.6124 71.585 46.4384 75.9965 47.1044L76.6625 46.7714L77.6195 47.1044L78.077 47.8124C78.077 47.8124 83.5715 49.3529 88.5245 49.0199C93.4775 48.6869 94.685 48.5624 94.685 48.5624L95.5175 47.1479C95.5175 47.1479 95.393 46.3574 94.9355 46.0244L95.1845 45.4424L96.1415 45.4004C96.1415 45.4004 95.975 43.3889 98.084 42.5564C100.193 41.7239 111.125 39.6149 111.125 39.6149C111.125 39.6149 114.455 37.3319 115.787 34.2284C117.119 31.1249 116.786 31.0409 116.786 31.0409L116.231 29.9594L112.346 29.8484L110.21 31.9289L108.962 32.0954L104.273 36.2579L89.4005 36.2024L86.279 43.1954L81.659 42.4469L80.744 41.3654C80.744 41.3654 77.5805 40.6169 76.9985 40.6574C76.4165 40.6979 75.9575 41.3654 75.9575 41.3654L70.7555 38.1599L70.673 36.5369C70.673 36.5369 69.674 35.4554 68.675 33.3734C67.676 31.2929 67.4675 30.4184 67.4675 30.4184L62.1815 28.7114C62.1815 28.7114 52.3595 28.9604 48.863 28.8359C45.3665 28.7114 37.916 28.6274 37.001 28.2119C36.086 27.7964 35.627 27.3374 35.627 27.3374L28.361 27.5174",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6255 27.3359L51.0665 27.0434L53.1485 26.2529H55.604L57.227 26.7944H63.221L62.18 28.7084",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0845 27.0434H66.176L66.863 27.4814H71.0585L72.086 26.7659H73.3625L73.889 27.1244V29.2079L73.3625 29.7194H71.2535L70.892 29.0699H70.088L69.866 29.7194H69.2L68.978 29.0144H67.952L67.466 30.4154",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M106.797 26.5439C106.797 26.5439 106.589 25.5449 105.674 25.4624C104.759 25.3799 99.8884 25.2539 99.8884 25.2539C99.8884 25.2539 99.3889 25.1294 98.4739 25.5029C97.5589 25.8764 91.6894 27.9164 91.6894 27.9164C91.6894 27.9164 89.9824 28.1489 89.8999 29.7179C89.8174 31.2869 91.4809 31.5779 91.4809 31.5779L97.8484 33.7004C97.8484 33.7004 99.0559 34.2464 99.8044 34.2239C100.553 34.2014 102.593 34.2239 102.593 34.2239C102.593 34.2239 103.092 34.6589 103.967 33.6599C104.841 32.6609 106.34 30.9134 106.34 30.9134L105.771 30.3719V29.3459L106.187 28.9859L106.214 28.4039L105.798 27.9599L105.825 27.0449L106.241 26.5454H106.796L106.797 26.5439Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.798 26.5439H109.67L111.793 27.7934V28.7639L109.49 30.8174L106.34 30.9149",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M114.317 27.0434V29.9024",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M115.927 27.0434V29.9489",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M116.676 26.5439L117.731 27.0434V29.9489L116.606 30.6854",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1548 21.6329H51.0263L52.6913 22.5209H54.9653L56.6858 21.6329L61.4318 21.3839",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35693 24.6299H47.8624L51.2344 23.2979H58.5184C58.5184 23.2979 59.4769 23.2484 60.1969 23.4974C60.6289 23.6459 60.9739 23.9024 60.9739 24.3389C60.9739 25.7144 58.5604 25.7129 58.5604 25.7129H51.1939L47.8639 24.6314",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1958 23.4974L63.5543 22.5209H69.7133L70.7963 23.4974V25.7114L68.9228 27.4814",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5532 24.5038H68.6737",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4741 29.7194C72.4741 29.7194 72.6406 32.4734 75.7756 34.2254C78.9106 35.9774 80.8531 35.1449 80.8531 35.1449L82.1566 35.1179C82.1566 35.1179 82.3231 36.5324 83.7661 36.4769C85.2091 36.4214 85.2361 35.0624 85.2646 34.6184C85.2931 34.1744 85.2646 30.5954 85.2646 30.5954C85.2646 30.5954 85.4866 29.1659 84.1276 28.5899C84.1276 28.5899 86.5411 27.4799 85.0711 25.5449C84.4951 24.7874 82.6291 24.5189 81.9076 26.2529C81.9076 26.2529 81.0481 25.1894 80.4646 24.9644C79.8811 24.7394 77.6626 24.9644 77.6626 24.9644L75.4981 26.5154L74.9986 26.0999H73.2781V26.7659L73.8886 27.1229V29.2079L73.3621 29.7194H72.4741V29.7194Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbineVariant);
export default __webpack_public_path__ + "static/media/Carbine Variant.0d3984c3525d57282724a130d547b652.svg";
export { ForwardRef as ReactComponent };